import { SelectMetadaConnectionForm } from '@modules/salesforce/shared/components/select-metadata-connection/select-metadata-connection-form';
import { useCreateConnection } from '../../../hooks';
import { SelectConnectionFormHeader } from './header/select-connection-form-header';
import { SelectMetadataFormActions } from './footer/select-metada';
import { useCallback, useContext, useMemo, useState } from 'react';
import { UserPreferenceContext } from '@contexts/user-preference-context';
import { SalesforceConnection } from '@modules/salesforce/models';
import { SalesforceConnectionsService } from '@modules/salesforce/services';
import { MetadataConnectionModalScreens, useSFConnectionState } from '@contexts/sf-connection-context';
import {toastify, useTranslation} from '@testsigma/atoms';
import { logErrorToSentry } from '@utils/common';
import { useLocation } from 'react-router-dom';

const MetadataConnectionSelectForm = () => {
  const location = useLocation();
  const isGlobalConnection =  location.pathname.includes('settings/salesforce_connections');
  const {
    handleClose,
  } = useCreateConnection(isGlobalConnection, null);
  const { t } = useTranslation();
  const { handleUpdateSelectedConnection , handleUpdateOverlayMode, handleMetadataConnection, handleUpdateMetadataConnectionModalScreen} = useSFConnectionState();
  const [selectedExistingConnection, setSelectedExistingConnection] =
    useState<SalesforceConnection | null>(null);

  const projectPreference = useContext(UserPreferenceContext).userPreference
    .preference.projectPreference;
  const applicationId = projectPreference?.selectedApplication.id;
  const { versionId } = projectPreference;

  const onConfirmSelection = async () => {
    if (!selectedExistingConnection) {
      return;
    }
    try {
      handleUpdateMetadataConnectionModalScreen(
        MetadataConnectionModalScreens.METADATA_SYNC_DATA_PREPARATION_SCREEN,
      );
      await SalesforceConnectionsService.updateVersionId({
        applicationVersionId: versionId,
        applicationId,
        connection: selectedExistingConnection
      });
      handleMetadataConnection(selectedExistingConnection);
      handleUpdateSelectedConnection(selectedExistingConnection);
      handleUpdateOverlayMode('none');
      toastify(t('metadata.linked.succesfully'), {
        type: 'success',
      });
    } catch (error) {
      handleUpdateOverlayMode('none');
      logErrorToSentry({ error });
    }
  };

  return (
    <form className='flex flex-col gap-4 '> 
        <SelectConnectionFormHeader />
        <SelectMetadaConnectionForm
          selectedConnection={selectedExistingConnection}
          setSelectedConnection={setSelectedExistingConnection}
        />
        <SelectMetadataFormActions
          handleClose={handleClose}
          onConfirmSelection={onConfirmSelection} 
        />
    </form>
  );
};

export { MetadataConnectionSelectForm };
